$(function() {
	
	if(!ebusy.kioskMode) {
	
		window.addEventListener("load", function() {
			
			// common options
			var options = {
				palette: {
			        popup: {
			    	    background: "#000"
			        },
			        button: {
			    	    background: "#f1d600"
			        }
			    },
				content: {
					link: ebusy.cookieConsent.cookieConsentLink,
					href: "/privacy-policy",
					message: ebusy.cookieConsent.cookieConsentMessage,
					dismiss: ebusy.cookieConsent.cookieConsentDismiss
				},
				cookie: {
					name: "ebusy_cookieconsent_status",
					domain: window.location.hostname
				}
			};
			
			window.cookieconsent.initialise(options);
		});
	}
});	
